<div class="wrapper">
    <form [formGroup]="dataprotectionProcessStepForm">
        <dataprotection *ngIf="!isValidationViewVisible && isDataprotectionNotificationVisible" [form]="dataprotectionProcessStepForm" [portalkonfiguration]="portalkonfiguration"></dataprotection>
        <validation-view [languageChangeCallbackFunction]="validationOnLanguageChangeFunction" *ngIf="isValidationViewVisible"></validation-view>
    </form>
</div>
<div class="sticky-bottom-container">
    <button kendoButton class="back-button" (click)="onBackClick()" aria-labelledby="backLabel">
        <span id="backLabel" translate>question.back</span>
        <i></i>
    </button>
    <button kendoButton class="save-and-next-button" (click)="onSubmitClick()" aria-labelledby="submitLabel" [disabled]="isSubmitDisabled">
        <span id="submitLabel" translate>submitdialogue.submit_send</span>
        <i></i>
    </button>
</div>